module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/rain-1-9ab60e672ab3d7c57a266f0b8fd55e92.svg";